// scheduling/components/idd/IDDRowMenu.jsx
// The "⋯" menu at the end of a row: the actions a manager needs rarely (history, remove the
// job, undo a whole-row state), kept out of the decision cell.
import { useEffect, useRef, useState } from 'react';

export default function IDDRowMenu({ items }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  const shown = (items || []).filter(Boolean);
  if (shown.length === 0) return null;
  return (
    <span className="idd-rowmenu" ref={ref} onClick={e => e.stopPropagation()}>
      <button className="idd-rowmenu-btn" aria-label="More actions" aria-expanded={open} onClick={() => setOpen(o => !o)}>⋯</button>
      {open && (
        <span className="idd-rowmenu-pop" role="menu">
          {shown.map(it => (
            <button
              key={it.label}
              role="menuitem"
              className={`idd-rowmenu-item${it.danger ? ' idd-rowmenu-item--danger' : ''}`}
              onClick={() => { setOpen(false); it.onClick(); }}
              title={it.title}
            >
              {it.label}
            </button>
          ))}
        </span>
      )}
    </span>
  );
}
